import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Wed Jul 18 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { jsonConversions, CRPDTOConverter, CompetitorReferentialPriceConverter } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
import logger from '../../logger';
export var CRPLayer =
/*#__PURE__*/
function () {
  function CRPLayer() {
    var _this = this;

    _classCallCheck(this, CRPLayer);

    this.baseUri = CONSTANTS.API.ENDPOINTS.CLEANING;

    this.findCRP = function (productId, competitorIds, priceZoneId) {
      var findCRPPromise = api("".concat(_this.baseUri).concat(CONSTANTS.API.ENDPOINTS.CRP)).post({
        productId: productId,
        competitorIds: competitorIds,
        priceZoneId: priceZoneId
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.competitorReferentialPriceConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return findCRPPromise;
    };
  }

  _createClass(CRPLayer, [{
    key: "findCRPAndFlags",
    value: function findCRPAndFlags(params) {
      var _this2 = this;

      var findCRPAndFlagsPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.CRPDTO)).get({
        params: params
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this2.CRPDTOconverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return findCRPAndFlagsPromise;
    }
    /** RFC LOG-3142 for cleaning modal */

  }, {
    key: "findNewCRP",
    value: function findNewCRP(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var endpoint, _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = "".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.NewCRP);
                _context.next = 3;
                return api(endpoint).get({
                  params: params
                });

              case 3:
                _ref = _context.sent;
                data = _ref.data;
                return _context.abrupt("return", data.result ? this.competitorReferentialPriceConverter.toObject(data.result, jsonConversions) : undefined);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return CRPLayer;
}();

__decorate([Inject, __metadata("design:type", CRPDTOConverter)], CRPLayer.prototype, "CRPDTOconverter", void 0);

__decorate([Inject, __metadata("design:type", CompetitorReferentialPriceConverter)], CRPLayer.prototype, "competitorReferentialPriceConverter", void 0);